<template>
	<!-- popular categories -->
	<div class="flex w-full justify-center px-3">
		<div class="w-full max-w-8xl">
			<div class="flex w-full justify-center">
				<div :class="['w-full xl:max-w-8xl grid grid-cols-2 gap-2', categories.length < 5 ? 'md:grid-cols-4' : 'md:grid-cols-5']">
					<router-link
						:to="`/categories${category.url.path}`"
						v-for="category in categories"
						:key="category.id"
						class="relative overflow-hidden rounded-lg w-full aspect-square max-w-82 group"
					>
						<div class="absolute inset-0 bg-center bg-cover" :style="`background-image: url(${category.imageUrl})`" />
						<div class="absolute inset-0 bg-gradient-to-t from-ihh-black/30 to-ihh-black/10 group-hover:opacity-75 transition-all" />
						<div class="absolute inset-0 flex items-end justify-center">
							<div class="before-hover w-full">
								<div class="absolute inset-0 flex w-full justify-center items-end !pb-4 p-2 text-center text-white">
									<div class="text-xl md:text-2xl font-semibold tracking-wide">
										{{ category.name }}
									</div>
									<!-- <div class="text-xs md:text-base">{{ category.description }}</div> -->
								</div>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['categories'],
}
</script>
